<template>
  <div class="reglement" data-model-id="3141:822">
    <div class="background-image-wrapper">
      <div class="background-image">
          <!-- <img
            class="freepik-expand"
            alt="Freepik expand"
            src="/img/freepik-green-long-grass.png"
          />
        <div class="background-overlay" /> 
        <div class="background" /> -->
      </div>
    </div>
    <div class="main-container">
      <header>
        <div class='burger-wrapper' v-show="tmode || mmode">
          <button class="burger-button" @click="toggleMobileMenu">
            <div class='line1' :class="{ 'active': mobileMenuOpen }"></div>
            <div class='line2' :class="{ 'active': mobileMenuOpen }"></div>
          </button>
        </div>
        
        <div class="navbar" v-show="wsmode">
          <router-link to="/" class="navbar-item">
            <span class="nav-text">Accueil</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/about" class="navbar-item">
            <span class="nav-text">Symabio</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/pagemembres" class="navbar-item">
            <span class="nav-text">Membres</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/reglement" class="navbar-item">
            <span class="nav-text">Réglementations</span>
            <div class="nav-underline"></div>
          </router-link>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="closeMobileMenu"></div>
        <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }" v-show="tmode || mmode">
          <div class="mobile-menu-header">
            <img src="/img/logo-symabio.png" alt="Logo Symabio" class="mobile-logo" />
          </div>
          <div class="mobile-menu-links">
            <router-link to="/" class="mobile-navbar-item" @click="closeMobileMenu">Accueil</router-link>
            <router-link to="/about" class="mobile-navbar-item" @click="closeMobileMenu">Symabio</router-link>
            <router-link to="/pagemembres" class="mobile-navbar-item" @click="closeMobileMenu">Membres</router-link>
            <router-link to="/reglement" class="mobile-navbar-item" @click="closeMobileMenu">Réglementations</router-link>
          </div>
          <div class="mobile-menu-footer">
            <div class="social-icons">
              <a href="#" class="social-icon"><img src="/img/gg-facebook.svg" alt="Facebook"></a>
              <a href="#" class="social-icon"><img src="/img/formkit-linkedin.svg" alt="LinkedIn"></a>
              <a href="#" class="social-icon"><img src="/img/akar-icons-instagram-fill.svg" alt="Instagram"></a>
            </div>
          </div>
        </div>

        <router-link to="/" class="logo">
          <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          />
        </router-link>
      </header>
      <div class="content-flex">
        <div class="subtitle">Réglementations en vigueur</div>
       
        
      </div>
      <CommentCertifier />
      <div class="lighttitle">Pourquoi Adopter et Manger Bio ?</div>
      <PourquoiBio />

      <div class="lighttitle">Pourquoi une certification ?</div>
      <PourquoiCertifier />

      <div class="lighttitle">Réglementations en vigueur</div>
      <p class="description-reglement">
        Vous êtes opérateurs de la filière bio et vous utilisez des produits
        certifiés par un organisme certificateur, vous souhaitez adhérer en tant
        qu'entreprise membre de notre syndicat ?
      </p>
      <ReglementCard />
    </div>
  </div>
</template>

<script>
import CommentCertifier from "./Reglement/sections/CommentCertifier.vue";
import PourquoiBio from "./Reglement/sections/PourquoiBio.vue";
import PourquoiCertifier from "./Reglement/sections/PourquoiCertifier.vue";
import ReglementCard from "./Reglement/sections/ReglementCard.vue";
import allMembresData from "@/membres.json"; // Import all members data

export default {
  name: "Reglement",
  components: {
    CommentCertifier,
    PourquoiBio,
    PourquoiCertifier,
    ReglementCard,
  },
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      showSearchResults: false,
      allMembers: allMembresData, // Store all members for searching
      mobileMenuOpen: false,
    };
  },
  props:{
    wsmode:{
      type: Boolean,
      default: false
    },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() { 
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleSearchInput() {
      if (this.searchQuery.length > 1) { 
        this.performSearch();
        this.showSearchResults = true;
      } else {
        this.searchResults = [];
        this.showSearchResults = false;
      }
    },
    performSearch() {
      if (!this.searchQuery) {
        this.searchResults = [];
        this.showSearchResults = false;
        return;
      }
      const lowerQuery = this.searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchResults = this.allMembers.filter(member => {
        const nom = (member['Nom de la société'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const zone = (member['Zone'] || member['Zone '] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const produits = (member['Produits Phares'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        return nom.includes(lowerQuery) || 
               zone.includes(lowerQuery) || 
               produits.includes(lowerQuery);
      });
      this.showSearchResults = this.searchResults.length > 0;
    },
    navigateToMember(numero) {
      if (numero) {
        this.$router.push(`/detailsMembres/${numero}`);
        this.showSearchResults = false; 
        this.searchQuery = ''; 
        this.searchResults = [];
      }
    },
    handleClickOutside(event) {
      const searchbarElement = this.$el.querySelector('.searchbar .input-container');
      if (searchbarElement && !searchbarElement.contains(event.target)) {
         this.showSearchResults = false;
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  }
};
</script>

<style>
.reglement {
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
}
.reglement header{
  /* background: linear-gradient(to right, #c5c69c, #cdc99c, #ceca9c) ; */
  background: #fff ;
  position: fixed;
  height: 120px;
  top:0;
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 99;

}
.reglement .burger-wrapper {
  z-index: 1000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.reglement .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.reglement .line1,.reglement .line2{
  border-radius: 2px;
  background: #3b723e;
  height: 3.1px;
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.reglement .line1{
  width: 40px;
}
.reglement .line2{
  width: 30px;
}

.reglement .line1.active {
  transform: rotate(45deg) translate(6px, 6px);
}
.reglement .line2.active {
  transform: rotate(-45deg) translate(7px, -7px);
  width: 40px;
}

/* Mobile Menu */
.reglement .mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.reglement .mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #fff;
  z-index: 999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
}

.reglement .mobile-menu.active {
  right: 0;
}

.reglement .mobile-menu-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.reglement .mobile-logo {
  height: 60px;
  width: auto;
}

.reglement .mobile-menu-links {
  flex: 1;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.reglement .mobile-navbar-item {
  display: block;
  padding: 16px 24px;
  color: #000;
  text-decoration: none;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s ease;
}

.reglement .mobile-navbar-item:hover {
  background-color: #f8f9fa;
}

.reglement .mobile-navbar-item.router-link-active {
  background-color: #3b723e;
  color: white;
}

.reglement .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #eee;
}

.reglement .social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.reglement .social-icon {
  display: block;
  width: 32px;
  height: 32px;
}

.reglement .social-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Global no-scroll class */
.no-scroll {
  overflow: hidden;
}
/* header logo navbar  */
.reglement .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.reglement .navbar-item {
  color: rgba(0, 0, 0, 0.85);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;
  width: fit-content;
  position: relative;
  padding: 8px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.reglement .nav-text {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.reglement .nav-underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a);
  transform: translateX(-50%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(59, 114, 62, 0.4);
}

/* Normal hover effect */
.reglement .navbar-item:hover {
  color: #000000;
  transform: translateY(-1px);
}

.reglement .navbar-item:hover .nav-underline {
  width: 100%;
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.6);
}

.reglement .navbar-item:hover .nav-text {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Active page styling (router-link-active) */
.reglement .navbar-item.router-link-active {
  color: #3b723e;
  font-weight: 500;
  transform: translateY(-1px);
}

.reglement .navbar-item.router-link-active .nav-text {
  text-shadow: 0 2px 12px rgba(59, 114, 62, 0.2);
  background: linear-gradient(135deg, #3b723e, #4caf50);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.reglement .navbar-item.router-link-active .nav-underline {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a, #4caf50, #3b723e);
  background-size: 200% 100%;
  animation: shimmer 2s ease-in-out infinite;
  box-shadow: 
    0 2px 8px rgba(59, 114, 62, 0.6),
    0 0 20px rgba(76, 175, 80, 0.3);
}

.reglement .navbar-item.router-link-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 114, 62, 0.05) 0%, transparent 70%);
  border-radius: 8px;
  z-index: 1;
  opacity: 0;
  animation: glow 2s ease-in-out infinite alternate;
}

/* Enhanced hover effect for active page */
.reglement .navbar-item.router-link-active:hover {
  transform: translateY(-2px);
}

.reglement .navbar-item.router-link-active:hover .nav-text {
  text-shadow: 0 4px 16px rgba(59, 114, 62, 0.3);
}

.reglement .navbar-item.router-link-active:hover .nav-underline {
  height: 4px;
  box-shadow: 
    0 4px 16px rgba(59, 114, 62, 0.8),
    0 0 30px rgba(76, 175, 80, 0.5);
}

/* Animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.reglement .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
}

.reglement .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.reglement .background-image-wrapper {
  position: fixed;
  background: #e6e3b5;
  background: #ffffff;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: -999;
}

.reglement .background-image {
  height: 100%;
}
.reglement .freepik-expand {
  opacity: 0.24;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}

.reglement .background-overlay {
  background: #01010114;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.reglement .background {
  mix-blend-mode: multiply;
  background: #e6e3b57d;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}

.reglement .main-container{
  /* background-color: white; */
  padding-top: 32px;
  height: 100%;
  width: 100vw;
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  /* overflow-x: hidden; */
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.reglement .overlap::-webkit-scrollbar {
  width: 8px;
}

.reglement .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.reglement .overlap::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}
.reglement .content-flex {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 20vh 8vw 24px 8vw;
}
.reglement .subtitle {
  color: #3b723e;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}

.reglement .searchbar {
  align-items: center;
  display: flex;
  gap: 12px; 
  width: 36%;
  position: relative; 
}

.reglement .input-container {
  width: -webkit-fill-available;
  position: relative; 
}
.reglement .input-container input {
  border: none;
  background: #fffde5cc;
  /* border-radius: 16px; */
  width: -webkit-fill-available;
  height: 64px;
  font-size: 20px;
  font-weight: 300;
  color: #3b723e;
  text-indent: 24px;
  outline-color:  #72703b ;
  outline-width: 2px;
  position: relative; /* For positioning the results list */
}

.search-results-list {
 list-style-type: none;
    margin-top: 0px;
    margin-left: -1px;
    padding: 0px;
    /* margin: 0; */
     position: absolute; 
    background-color: #fffde5cc;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 16px 16px;
    width: calc(100% - -2px);
    max-height: 207px;
    overflow-y: auto;
}

.search-results-list li {
  padding: 10px 24px; 
  cursor: pointer;
  color: #3b723e; 
  border-bottom: 1px solid #eee; 
}

.search-results-list li:last-child {
  border-bottom: none; 
}

.search-results-list li:hover {
  background-color: #e6e3b5; 
}

.reglement .input-container input::placeholder{
  color: #3b723e;
  font-weight: 200;
}

.reglement .divider{
  height: 4vh;
}

.reglement .lighttitle {
  color: #000000;
  font-family: "Bw Modelica SS02";
  font-size: 24px;
  font-weight: 600;
  margin: 8vh 8vw 24px 8vw;
  /* left: 104px; */
  letter-spacing: 0;
  line-height: 36px;
  /* position: absolute; */
  /* top: 440px; */
  white-space: nowrap;
}


.reglement .description-reglement {
  color: #000000;
  margin: 0px 8vw;
  padding-left: 12px;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  /* left: 115px; */
  letter-spacing: 0;
  line-height: 20px;
  /* position: absolute; */
  /* top: 1152px; */
  width: 32vw;
}
@media (max-height: 1200px){
  .reglement .freepik-expand {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}
@media (max-width: 1200px){
  .reglement .description-reglement {
    width: -webkit-fill-available; 
  }
}

@media (max-width: 1023px) {
  .reglement .content-flex {
    margin: 140px 6vw 24px 6vw;
  }
  .reglement .subtitle {
    font-size: 36px;
  }
  .reglement .lighttitle {
    margin: 6vh 6vw 20px 6vw;
    font-size: 22px;
  }
  .reglement .description-reglement {
    margin: 0px 6vw;
    font-size: 14px;
    line-height: 22px;
  }
}

@media (max-width: 773px){
  .reglement .content-flex {
    margin: 132px 6vw 24px 6vw;
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
  }
  .reglement .subtitle {
    font-size: 32px;
    width: -webkit-fill-available;
  }
  .reglement .searchbar {
    width: -webkit-fill-available;
  }
  .reglement .lighttitle {
    margin: 5vh 6vw 16px 6vw;
    font-size: 20px;
    line-height: 28px;
  }
}

@media (max-width: 567px) {
  .reglement .content-flex {
    margin: 120px 4vw 20px 4vw;
  }
  .reglement .subtitle {
    font-size: 28px;
  }
  .reglement .lighttitle {
    margin: 4vh 4vw 12px 4vw;
    font-size: 18px;
    line-height: 26px;
  }
  .reglement .description-reglement {
    margin: 0px 4vw;
    font-size: 13px;
    line-height: 20px;
  }
}

@media (max-width: 480px) {
  .reglement .subtitle {
    font-size: 24px;
  }
  .reglement .lighttitle {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>